import { render, staticRenderFns } from "./Sklep.vue?vue&type=template&id=99366f26"
import script from "./Sklep.vue?vue&type=script&lang=js"
export * from "./Sklep.vue?vue&type=script&lang=js"
import style0 from "./Sklep.vue?vue&type=style&index=0&id=99366f26&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports